<template>
    <div class="shadow-md p-3 font-primary">
      <div v-if="cargando" class="absolute w-full flex justify-center">
        <img class="w-44" src="https://thebowlcut.com/cdn/shop/t/41/assets/loading.gif?v=157493769327766696621701744369" alt="">
      </div>
      <div>
        <h1 class="text-3xl mb-5">Descargar catalogos</h1>
        <div class="flex justify-center">
          <div>
            <div class="flex gap-4">
              <div>
                <p>Incluir Logo</p>
                <input type="checkbox" v-model="logo">
              </div>
              <div>
                <p>Incluir Precio</p>
                <input type="checkbox" v-model="precio">
              </div>
            </div>
            <div class="flex justify-between gap-3 w-96 p-2" v-for="(marca, key) in marcas" :key="key">
              <p>{{ marca.Nombre }}</p>
              <div class="flex gap-2">
                <button :disabled="cargando" @click="generarCatalogo(marca.IDMarca)" class="btn btn-danger btn-sm">Descargar</button>
                <button :disabled="cargando" @click="generarLp(marca.IDMarca)" class="btn btn-danger btn-sm">Lista de precios</button>
              </div>
            </div>
          </div>
        </div>
        <p class="text-red" v-if="cargando">Espere hasta que finalice la descarga. esto puede demorar un momento</p>
      </div>
    </div>
  </template>
  
  <script>
  import pedidosService from '@/services/pedidos.service';
  export default {
    data() {
      return {
        cargando: false,
        marcas: [],
        logo: true,
        precio: true
      };
    },
    mounted() {
      this.getMarcas()
    },
    methods: {
    getMarcas() {
      pedidosService.getMarcas()
        .then((res) => {
          this.marcas = res.data
        })
        .catch((e) => console.log(e))
    },
    generarLp(id) {
      this.cargando = true
      pedidosService.generarListaPrecios(id)
        .then((response) => {

        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
        const year = today.getFullYear();
        link.download = 'lista-precios-'+`${day}-${month}-${year}`+'.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {console.log(err)})
      .finally(() => {this.cargando = false})
    },
    generarCatalogo(id) {
      this.cargando = true
      pedidosService.generarCatalogo(this.logo ? 1 : 0, 1, this.precio ? 1 : 0, id, null, null)
        .then(res => {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          const today = new Date();
          const day = String(today.getDate()).padStart(2, '0');
          const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
          const year = today.getFullYear();
          link.setAttribute('download', 'catalogo-'+`${day}-${month}-${year}`+'.pdf'); // Set the filename for the downloaded file
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((er) => {
          console.log(er)
        })
        .finally(() => {
          this.cargando = false
        })
      },
    },
    computed: {
    },
  };
  </script>

